export class BaseHttpAdapter {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
}
//# sourceMappingURL=public-api.js.map